import React from 'react';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';

const HtmlRenderer = ({ texts, sanitizeHtml }) => {
    return (
        <>
            {texts.map((item, idx) => {
                if (sanitizeHtml) {
                    const isHTML = /<\/?[a-z][\s\S]*>/i.test(item);
                    if (isHTML) {
                        const sanitizedHTML = DOMPurify.sanitize(item);
                        return <span key={idx} dangerouslySetInnerHTML={{ __html: sanitizedHTML }} />;
                    }
                }
                return <span key={idx}>{item}</span>;
            })}
        </>
    );
};

HtmlRenderer.propTypes = {
    texts: PropTypes.arrayOf(PropTypes.string).isRequired,
    sanitizeHtml: PropTypes.bool.isRequired
};

export default HtmlRenderer;
